import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AuthSession } from '@safe-minds-ai/api';

export interface AuthState {
  status: 'unknown' | 'authenticated' | 'unauthenticated' | 'loading';
  session: AuthSession | null;
  popChallengeId: string | null;
}

const initialState: AuthState = {
  status: 'unknown',
  session: null,
  popChallengeId: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setSession(state, action: PayloadAction<AuthSession>) {
      state.session = action.payload;
      state.status = 'authenticated';
    },
    setStatus(state, action: PayloadAction<AuthState['status']>) {
      state.status = action.payload;
    },
    signOut(state) {
      state.session = null;
      state.status = 'unauthenticated';
      state.popChallengeId = null;
    },
    setPopChallenge(state, action: PayloadAction<string | null>) {
      state.popChallengeId = action.payload;
    },
  },
});

export const { setSession, setStatus, signOut, setPopChallenge } = authSlice.actions;
export const authReducer = authSlice.reducer;
